// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCrab = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M11 13.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0m3.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3" />,
    <path
      fillRule="evenodd"
      d="M4.5 4A1.5 1.5 0 106 5.5h2a3.5 3.5 0 01-4 3.465V10c0 .819.328 1.561.86 2.103C6.415 9.65 9.008 8 12 8s5.585 1.65 7.14 4.103A3 3 0 0020 10V8.965Q19.755 9 19.5 9A3.5 3.5 0 0116 5.5h2A1.5 1.5 0 1019.5 4V2a3.5 3.5 0 012.45 6H22v2a5 5 0 01-1.938 3.953l.02.047-.157.381a9.6 9.6 0 01-2.334 3.381l1.823 1.824L18 21l-2.044-2.044a8 8 0 01-.956.46V22h-2v-2.062a8 8 0 01-2 0V22H9v-2.583a8 8 0 01-.956-.46L6 21l-1.414-1.414 1.823-1.824a9.6 9.6 0 01-2.333-3.38L3.918 14l.02-.047A4.99 4.99 0 012 10V8h.05A3.5 3.5 0 014.5 2zM12 18c-2.51 0-4.758-1.578-5.907-4 1.15-2.422 3.396-4 5.907-4 2.51 0 4.758 1.578 5.907 4-1.15 2.422-3.396 4-5.907 4"
    />
  );
export default SvgIconCrab;
